module.exports = __webpack_public_path__ + "static/media/unx_bar_system.b741ea83.JPG";